// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd2-cls1_8sr","cls2":"PodcastLibraryAd2-cls2_hWw PodcastLibraryAd2-cls1_8sr"};